import { IComponentOptions } from "angular";
import { MachinesViewController } from "./controller";
export const vsComponentName = "machineDetailMachinesView";
export const MachineDetailMachinesViewComponentOptions: IComponentOptions =
{
  controller: MachinesViewController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    contractMachines: "<",
  },
};
